import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { legacyTicketsCategoryPathToUrl } from "../Components/PagesCompoents/TicketsPage/ticketsCategoryCatalog";

/** Redirect legacy `/tickets/category=:id` URLs to `/tickets?category=...&categoryId=...` */
const Category = () => {
  const { name } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(legacyTicketsCategoryPathToUrl(name), { replace: true });
  }, [name, navigate]);

  return null;
};

export default Category;
